/**
 * A concept whose display word the organization can rename. The values are
 * the wire keys of the vocabulary map and the route segment of the
 * vocabulary endpoints. Contract and Payment are never slots.
 */
export enum VocabularySlot {
  Member = "member",
  Session = "session",
  Instructor = "instructor",
  Occurrence = "occurrence",
  Group = "group",
  Visit = "visit",
  Programme = "programme",
}

export const VOCABULARY_SLOTS: readonly VocabularySlot[] = Object.values(VocabularySlot);

/** The locales an organization can rename; Arabic reads its fixed Default words (defaultVocabulary). */
export const VOCABULARY_LOCALES: readonly string[] = ["en", "de", "uk", "pl", "ja"];
